var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3034_56932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4C10.4178 4 8.87104 4.46919 7.55544 5.34824C6.23985 6.22729 5.21447 7.47672 4.60897 8.93853C4.00347 10.4003 3.84504 12.0089 4.15372 13.5607C4.4624 15.1126 5.22433 16.538 6.34315 17.6569C7.46197 18.7757 8.88743 19.5376 10.4393 19.8463C11.9911 20.155 13.5997 19.9965 15.0615 19.391C16.5233 18.7855 17.7727 17.7602 18.6518 16.4446C19.5308 15.129 20 13.5822 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4ZM12 18.6667C10.6815 18.6667 9.39253 18.2757 8.2962 17.5431C7.19987 16.8106 6.34539 15.7694 5.84081 14.5512C5.33622 13.333 5.2042 11.9926 5.46144 10.6994C5.71867 9.40619 6.35361 8.2183 7.28596 7.28595C8.21831 6.3536 9.4062 5.71867 10.6994 5.46143C11.9926 5.2042 13.3331 5.33622 14.5512 5.8408C15.7694 6.34539 16.8106 7.19987 17.5431 8.2962C18.2757 9.39253 18.6667 10.6815 18.6667 12C18.6667 12.8755 18.4942 13.7424 18.1592 14.5512C17.8242 15.3601 17.3331 16.095 16.714 16.714C16.095 17.3331 15.3601 17.8242 14.5512 18.1592C13.7424 18.4942 12.8755 18.6667 12 18.6667Z",
    fill: "#F02532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 13.3798C11.7696 13.3798 11.5492 13.2885 11.3867 13.126C11.2241 12.9634 11.1328 12.743 11.1328 12.5132V8.51315C11.1328 8.2833 11.2241 8.06286 11.3867 7.90033C11.5492 7.73779 11.7696 7.64648 11.9995 7.64648C12.2293 7.64648 12.4498 7.73779 12.6123 7.90033C12.7748 8.06286 12.8661 8.2833 12.8661 8.51315V12.5132C12.8661 12.743 12.7748 12.9634 12.6123 13.126C12.4498 13.2885 12.2293 13.3798 11.9995 13.3798Z",
    fill: "#F02532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9688 16.3467C12.521 16.3467 12.9688 15.899 12.9688 15.3467C12.9688 14.7944 12.521 14.3467 11.9688 14.3467C11.4165 14.3467 10.9688 14.7944 10.9688 15.3467C10.9688 15.899 11.4165 16.3467 11.9688 16.3467Z",
    fill: "#F02532"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3034_56932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.0b39026d.svg";
export { ForwardRef as ReactComponent };